<template>
    <div v-if="!darkMode" class="container">

        <div class="mesLogos">
        <router-link to="/">
          <img src="@/assets/home_blue.png" alt="logo Accueil" class="logo" />
        </router-link>
        <router-link to="/projets">
          <img src="@/assets/arrow_back_blue.png" alt="Arrow back" class="logo" />
        </router-link>
        </div>

        <div class="gallery">

            <input type="checkbox" />

        <h1>Front-End</h1>

            <img src="@/assets/cssGridResponsive.png" alt="grid responsable" />
            <img src="@/assets/slider.png" alt="slider" />
            <img src="@/assets/cube3d.png" alt="cube 3D" />
            <img src="@/assets/eventsSite.png" alt="evenements site" />
            <img src="@/assets/galleryEffect.png" alt="gallery effets" />
            <img src="@/assets/loading.png" alt="loading" />
            <img src="@/assets/morpion.png" alt="morpion" />
            <img src="@/assets/shi-fu-mi.png" alt="shi fu mi" />
            <img src="@/assets/monPortfolio.png" alt="mon portfolio" />


        </div>


    </div>

    <div v-if="darkMode" class="container">

        <div class="mesLogos">
        <router-link to="/">
          <img src="@/assets/home_white.png" alt="logo Accueil" class="logo" />
        </router-link>
        <router-link to="/projets">
          <img src="@/assets/arrow_back_white.png" alt="Arrow back" class="logo" />
        </router-link>
        </div>

    <div class="galleryDark">

    <input type="checkbox" />

    <h1 class="h1Dark">Front-End</h1>

    <img src="@/assets/cssGridResponsive.png" alt="grid responsable" />
    <img src="@/assets/slider.png" alt="slider" />
    <img src="@/assets/cube3d.png" alt="cube 3D" />
    <img src="@/assets/eventsSite.png" alt="evenements site" />
    <img src="@/assets/galleryEffect.png" alt="gallery effets" />
    <img src="@/assets/loading.png" alt="loading" />
    <img src="@/assets/morpion.png" alt="morpion" />
    <img src="@/assets/shi-fu-mi.png" alt="shi fu mi" />
    <img src="@/assets/monPortfolio.png" alt="mon portfolio" />


</div>


</div>
</template>

<script>
export default {
    name: 'FrontEnd',

    computed: {
    darkMode(){
      return this.$store.state.darkMode
    }
  },

}
</script>

<style scoped>
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    transition: transform 0.5s ease;
    padding-top: 2rem;
    color: #004080;
    position: relative;
}

.h1Dark{
  color: white;
}

.mesLogos{
  position: absolute;
  top: 10px;
  left: 10px;
}

.mesLogos img{
  width: 30px;
  height: auto;
}

h1{
    top: 10rem;
    left: 40%;
    position: absolute;
}

.gallery {

  --size: 200px;

  display: grid;
  grid-template-columns: repeat(3, auto);
  position: relative;
  gap: 5px;
}

.galleryDark {
    
  --size: 200px;

    display: grid;
    grid-template-columns: repeat(3, auto);
    position: relative;
    gap: 5px;
}

.gallery input{
    position: absolute;
    border: 2px solid #004080;
    border-radius: 50%;
    inset: calc(50% - var(--size) / 3);
    cursor: pointer;
    --g: linear-gradient(#004080 0 0) no-repeat;
    background: var(--g) 50%/var(--b, 0%) 3px, var(--g) 50%/3px var(--b, 0%);
    transition: 1.5s;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.gallery > input:checked::before {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: #004080;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
}

.gallery > input:checked::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: #004080;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
}

.galleryDark input{
    position: absolute;
    border: 2px solid white;
    border-radius: 50%;
    inset: calc(50% - var(--size) / 3);
    cursor: pointer;
    --g: linear-gradient(white 0 0) no-repeat;
    background: var(--g) 50%/var(--b, 0%) 3px, var(--g) 50%/3px var(--b, 0%);
    transition: 1.5s;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.galleryDark > input:checked::before {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px; 
    background-color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
}

.galleryDark > input:checked::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
}


.gallery input::after {
  transform: translate(-50%, -50%) rotate(90deg);
}

.galleryDark input::after {
  transform: translate(-50%, -50%) rotate(90deg);
}

.gallery > img {
  width: var(--size);
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  transform: scale(0.1);
  filter: brightness(0);
  pointer-events: none;
  transform-origin: var(--x) var(--y);
  transition: 1s calc((var(--i) - 1) * 0.1s);
}

.galleryDark > img {
  width: var(--size);
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  transform: scale(0.1);
  filter: brightness(0);
  pointer-events: none;
  transform-origin: var(--x) var(--y);
  transition: 1s calc((var(--i) - 1) * 0.1s);
}

.gallery > img:nth-of-type(1){--i:1;--x: 150%;--y:150%;}
.gallery > img:nth-of-type(2) {--i:2;--x:  50%;--y:150%;}
.gallery > img:nth-of-type(3) {--i:3;--x: -50%;--y:150%;}
.gallery > img:nth-of-type(4) {--i:4;--x: 150%;--y:50%; }
.gallery > img:nth-of-type(5) {--i:5 }
.gallery > img:nth-of-type(6) {--i:6;--x: -50%;--y:50%; }
.gallery > img:nth-of-type(7) {--i:7;--x: 150%;--y:-50%;}
.gallery > img:nth-of-type(8) {--i:8;--x:  50%;--y:-50%;}
.gallery > img:nth-of-type(9) {--i:9;--x: -50%;--y:-50%;}

.galleryDark > img:nth-of-type(1){--i:1;--x: 150%;--y:150%;}
.galleryDark > img:nth-of-type(2) {--i:2;--x:  50%;--y:150%;}
.galleryDark > img:nth-of-type(3) {--i:3;--x: -50%;--y:150%;}
.galleryDark > img:nth-of-type(4) {--i:4;--x: 150%;--y:50%; }
.galleryDark > img:nth-of-type(5) {--i:5 }
.galleryDark > img:nth-of-type(6) {--i:6;--x: -50%;--y:50%; }
.galleryDark > img:nth-of-type(7) {--i:7;--x: 150%;--y:-50%;}
.galleryDark > img:nth-of-type(8) {--i:8;--x:  50%;--y:-50%;}
.galleryDark > img:nth-of-type(9) {--i:9;--x: -50%;--y:-50%;}

.gallery > input:checked ~ img {
  transform: scale(1);
  filter: brightness(1);
  pointer-events: initial;
}

.galleryDark > input:checked ~ img {
  transform: scale(1);
  filter: brightness(1);
  pointer-events: initial;
}

.gallery > input:checked {
  top: 0;
  left: 630px;
  width: 2rem;
  height: 2rem;
  transform: translateY(calc(1.75*var(--s))) scale(.5) rotate(45deg);
  --b: 70%;
  background: none;
  z-index: 10;
}

.galleryDark > input:checked {
  top: 0;
  left: 630px;
  width: 2rem;
  height: 2rem;
  transform: translateY(calc(1.75*var(--s))) scale(.5) rotate(45deg);
  --b: 70%;
  background: none;
  z-index: 10;
}

.gallery > input:checked::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.galleryDark > input:checked::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.gallery > input:checked::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.galleryDark > input:checked::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.gallery input:checked ~ h1 {
    transform: translateY(-200px);
}

.galleryDark input:checked ~ h1 {
    transform: translateY(-200px);
}

</style>